import React, { forwardRef, ForwardedRef, SelectHTMLAttributes } from 'react';
import { Form, FormControlProps } from 'react-bootstrap';
import HelperText, { HelperTextProps } from '../Form/HelperText';
import { Ioption } from '../type';

export interface SelectProps
  extends FormControlProps,
    Omit<
      SelectHTMLAttributes<HTMLSelectElement>,
      'name' | 'onChange' | 'value' | 'size'
    >,
    HelperTextProps {
  /** 欄位名稱(改為 required) */
  name: string;
  options: Ioption[];
  /** 是否顯示 placehoder */
  showPlaceholder?: boolean;
}

const Select = forwardRef(
  (props: SelectProps, ref: ForwardedRef<HTMLSelectElement>): JSX.Element => {
    const {
      placeholder = '請選擇…',
      showPlaceholder,
      options = [],
      error,
      helperText,
      className = 'form-control',
      ...other
    } = props;

    return (
      <>
        <Form.Control
          // custom
          as="select"
          ref={ref}
          isInvalid={error}
          {...{ className, ...other }}
        >
          <option value="" hidden={!showPlaceholder}>
            {placeholder}
          </option>
          {options.map((obj) => (
            <option key={obj.value} value={obj.value} disabled={obj.disabled}>
              {obj.label}
            </option>
          ))}
        </Form.Control>
        <HelperText {...{ error, helperText }} />
      </>
    );
  },
);

Select.displayName = 'Select';
export default Select;
